<template>
  <div class="judgeme-icon" :style="style"></div>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'JudgeMeLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
  computed: {
    style() {
      return `width: ${this.width}; height: ${this.height};`;
    },
  },
};
</script>

<style lang="scss">
.judgeme-icon {
  background-image: url('../../images/judgeme.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  display: inline-block;
  height: 32px;
  width: 32px;
}
</style>
